import { EmptyState } from "./EmptyState";
import { GiphyGrid } from "./GiphyGrid";
import { GiphyGridSkeleton } from "./GiphyGridSkeleton";
import type { GiphyItem } from "./types";

interface PickerBodyProps {
  fetchNextPage: () => void;
  gifs: GiphyItem[];
  hasNextPage: boolean;
  isDisabled: boolean;
  isInitialLoading: boolean;
  onSelect: (gif: GiphyItem) => void;
}

export const PickerBody = ({
  gifs,
  isInitialLoading,
  hasNextPage,
  fetchNextPage,
  isDisabled,
  onSelect,
}: PickerBodyProps) => {
  if (isInitialLoading) {
    return <GiphyGridSkeleton />;
  }

  if (!gifs.length) {
    return <EmptyState />;
  }

  return (
    <GiphyGrid
      gifs={gifs}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isDisabled={isDisabled}
      onSelect={onSelect}
    />
  );
};
